import { createHandlerChainRunnerOptionalParameter, Handler } from "@insite/client-framework/HandlerCreator";

export const ClearForm: Handler = props => {
    props.dispatch({
        type: "Custom/CampaignForm/ClearForm",
    } as any);
};

export const chain = [ClearForm];

const clearForm = createHandlerChainRunnerOptionalParameter(chain, {}, "ClearForm");
export default clearForm;
